import type { ReactNode } from 'react';
import { DOCS_URL, IconNota, PORTAL_URL } from '@fa/ui';

/**
 * Cabecalho e rodape, compartilhados pela home e pelas paginas corporativas.
 *
 * Estavam embutidos na home. Duplica-los nas paginas novas garantiria que um
 * dia o menu mudasse em um lugar so — e o rodape e justamente onde ficam os
 * links que a lei exige estarem sempre acessiveis.
 */

export function Header({ compacto = false }: { compacto?: boolean }): ReactNode {
  return (
    <header>
      <div className="wrap nav">
        <a className="logo" href="/">
          <i>
            <IconNota />
          </i>{' '}
          FA Tech Notas
        </a>
        {/* Numa pagina juridica o menu de secoes da home nao leva a lugar
            nenhum: as ancoras sao de outra pagina. */}
        {!compacto && (
          <ul>
            <li>
              <a href="#como">Como funciona</a>
            </li>
            <li>
              <a href="#recursos">Recursos</a>
            </li>
            <li>
              <a href="#api">API</a>
            </li>
            <li>
              <a href="#planos">Planos</a>
            </li>
            <li>
              <a href={DOCS_URL}>Documentação</a>
            </li>
          </ul>
        )}
        <div style={{ display: 'flex', gap: 10 }}>
          <a className="btn btn-ghost btn-sm" href={PORTAL_URL}>
            Entrar
          </a>
          <a className="btn btn-primary btn-sm" href={compacto ? '/#planos' : '#planos'}>
            Criar conta
          </a>
        </div>
      </div>
    </header>
  );
}

export function Footer(): ReactNode {
  return (
    <footer>
      <div className="wrap">
        <span>FA Tech Notas é um produto da FA Tech Ltda · CNPJ 62.103.780/0001-52</span>
        <nav aria-label="Links institucionais">
          <a href={DOCS_URL}>Documentação</a>
          <a href="/termos">Termos de uso</a>
          <a href="/privacidade">Privacidade</a>
        </nav>
      </div>
    </footer>
  );
}
